module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "base-bg"
  }, [_c('div', {
    staticClass: "nav-bar"
  }, [_c('div', {
    staticClass: "btn-wrapper"
  }, [_c('blue-btn', {
    attrs: {
      "info": "返回",
      "handle-click": _vm.cancel
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "desc-block img-block"
  }, [_c('p', [_vm._v("课程签到")]), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [_c('card-view', [_c('div', {
    staticClass: "faBox",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm.$route.params.signStatus == '0') ? [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border-radius": "10px"
    },
    attrs: {
      "src": _vm.bgPic
    },
    on: {
      "click": _vm.showPreview
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textQian"
  }, [_c('span', [_vm._v("签字后>>")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border-radius": "10px"
    },
    attrs: {
      "src": _vm.makePic
    },
    on: {
      "click": _vm.showPreview1
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "boxEsign"
  }, [_c('vue-esign', {
    ref: "esign",
    staticStyle: {
      "border": "1px solid black",
      "margin-top": "5px",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "isCrop": _vm.isCrop,
      "lineWidth": _vm.lineWidth,
      "lineColor": _vm.lineColor,
      "bgColor": _vm.bgColor
    },
    on: {
      "update:bgColor": function($event) {
        _vm.bgColor = $event
      },
      "update:bg-color": function($event) {
        _vm.bgColor = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("清空画板")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.drawProdPicture
    }
  }, [_vm._v("完成签字")])], 1)] : [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border-radius": "10px"
    },
    attrs: {
      "src": _vm.makePic
    },
    on: {
      "click": _vm.showPreview1
    }
  })]], 2)]), _vm._v(" "), (_vm.$route.params.signStatus == '0') ? [_c('div', {
    staticClass: "btn-wrapper2"
  }, [_c('blue-btn', {
    attrs: {
      "info": "提交",
      "handle-click": _vm.submit
    }
  })], 1)] : _vm._e()], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0f7fdc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/signature.vue
// module id = 794
// module chunks = 1